"use client";

import type { CSMenuItem } from "@/types";
import { CURRENCY } from "@/config";
import { Star } from "lucide-react";
import Image from "next/image";

interface MenuItemCardProps {
  item: CSMenuItem;
}

export default function MenuItemCard({ item }: MenuItemCardProps) {
  const starIds = ["s1", "s2", "s3", "s4", "s5"];

  return (
    <div className="group">
      <div className="relative overflow-hidden rounded-2xl mb-6">
        <div className="relative w-full h-64">
          <Image
            src={item.imageSrc}
            alt={item.title}
            fill
            className="object-cover transition-transform duration-700 group-hover:scale-105"
            sizes="(max-width: 1024px) 100vw, 50vw"
            unoptimized
          />
        </div>
        <div className="absolute top-4 left-4">
          <span className="bg-black text-white px-3 py-1 rounded-full text-xs font-bold bg-opacity-90">
            {item.category}
          </span>
        </div>
        <div className="absolute bottom-4 left-4">
          <span className="text-3xl font-bold text-white">{item.index}</span>
        </div>
        <div className="absolute bottom-4 right-4">
          <span className="text-3xl font-bold text-white">
            {CURRENCY}
            {item.price}
          </span>
        </div>
      </div>
      <h3 className="text-2xl font-bold text-black mb-3">{item.title}</h3>
      <p className="text-black/70 leading-relaxed mb-4">{item.description}</p>
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-1">
          {starIds.map((id) => (
            <Star
              key={id}
              className="w-4 h-4 text-yellow-500"
              fill="currentColor"
              aria-hidden="true"
            />
          ))}
          <span className="text-sm text-black/60 ml-2">(5.0)</span>
        </div>
        <button
          type="button"
          className="text-black hover:text-black/70 transition-colors font-medium cursor-pointer"
        >
          Order Now →
        </button>
      </div>
    </div>
  );
}
